import { render, staticRenderFns } from "./PillarPracticeTypeStatus.vue?vue&type=template&id=46ba7fc0&scoped=true"
import script from "./PillarPracticeTypeStatus.vue?vue&type=script&lang=js"
export * from "./PillarPracticeTypeStatus.vue?vue&type=script&lang=js"
import style0 from "./PillarPracticeTypeStatus.vue?vue&type=style&index=0&id=46ba7fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba7fc0",
  null
  
)

export default component.exports